import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import { Typography, useTheme, useMediaQuery, Tooltip, ClickAwayListener} from '@mui/material';

const keyStyle = {
    fontSize: 10,
    color: 'rgba(157, 157, 157, 1)',
    margin: 0,
    padding: 0
}
const blueKeyStyle = {
    fontSize: 10,
    color: 'rgba(178, 235, 177, 1)',
    margin: 0,
    padding: 0
}


export default function SmallKeyValue(props) {
    const { keyLabel, value, highlighted, alignItems="start" } = props
    const [openTooltip, setOpenTooltip] = React.useState(false)
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.down('md'))

    const handleTooltipClose = () => {
        setOpenTooltip(false);
      };
    
    const handleTooltipOpen = () => {
    setOpenTooltip(true);
    };

    const toggleTooltip = () => {
        setOpenTooltip((prev) => !prev)
    }

    const valueStyle = {
        fontSize: 13,
        color: 'white',
        margin: 0,
        padding: 0,
        overflow:'hidden',
        textOverflow: 'ellipsis',
        width: '100%'
    }
    return (
        <Box flexShrink={0}> 
            <ClickAwayListener onClickAway={handleTooltipClose}>

                <Tooltip
                    onClose={handleTooltipClose}
                    open={openTooltip}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    title={value}
                    slotProps={{
                        popper: {
                            disablePortal: true
                        }
                    }}
                >
                    <Box 
                        onClick={toggleTooltip}
                        sx={{ 
                            height: 'auto',
                            overflow: 'hidden'
                        }}
                    >
                        <Box
                            display="flex"
                            flexDirection="column"
                            alignItems={alignItems}
                            sx={{width: '100%'}}
                            m={1}>
                                <Typography style={highlighted ? blueKeyStyle : keyStyle}>{keyLabel}</Typography>
                                <Typography style={valueStyle}>{value}</Typography>
                        </Box>
                    </Box>
                </Tooltip>
            </ClickAwayListener>
        </Box>
    );
}
